<!--收藏夹轮播图 -->
<template>
  <div class="slider">
    <div class="banner" v-if="coverimgList">
      <ul class="container" :style="containerStyle">
        <li v-for="(item, index) in coverimgList" :key="index">
          <div class="shield" :class="{actived:index === currentIndex}"></div>
          <img :src="item.CoverImg" alt>
        </li>
       
      </ul>
      <ul class="direction">
        <li class="left" @click="move(200, 1)"  v-if="currentIndex!=0">
          <img src="../../assets/img/left_btn.png" alt>
        </li>
        <li class="right" @click="move(200, -1)" v-if="currentIndex!=(coverimgList.length-1)">
          <img src="../../assets/img/right_btn.png" alt>
        </li>
      </ul>
      <!-- 轮播点 -->
      <!-- <ul class="dots">  
        <li v-for="(dot, i) in coverimgList" :key="i" 
        :class="{dotted: i === (currentIndex)}"
        >
        </li>
      </ul> -->
    </div>
  </div>
</template>
 
<script>
export default {
  name: "slider",
  props: {
    coverimgList:{
      type: Array,
      dafault: []
    },
  },
  data() {
    return {
      currentIndex: 1,//当coverimgList长度为1时设置成0
      distance: -200,//当coverimgList长度为1时设置成0
      transitionEnd: true,
  
    };
  },
  mounted(){
    if(this.coverimgList.length==1){
      this.currentIndex = 0;
      this.distance = 0;
    }
    this.$emit('getIndex',this.currentIndex);
  },
  methods: {
    move(offset, direction) {
      const len = this.coverimgList.length;
      if (!this.transitionEnd) return; //这里是闸
      this.transitionEnd = false; //开闸以后再把闸关上
      direction === -1 ? this.currentIndex++ : this.currentIndex--;
      if (this.currentIndex > len - 1) this.currentIndex = 0;
      if (this.currentIndex < 0) this.currentIndex = len - 1;
      const destination = this.distance + offset * direction;
      this.animate(destination, direction, offset, len);
    },

    animate(des, direc, offset, len) {
      if (this.temp) {
        window.clearInterval(this.temp);
        this.temp = null;
      }
      this.temp = window.setInterval(() => {
        if (
          (direc === -1 && des < this.distance) ||
          (direc === 1 && des > this.distance)
        ) {
          this.distance += 10 * direc;
        } else {
          this.transitionEnd = true; //闸再次打开
          window.clearInterval(this.temp);
          this.distance = des;
          if (des < -(len - 1) * offset) this.distance =0;
          
          if (des > 0) this.distance = -(len - 1) * offset;
        }
      }, 20);
    },
  },
  computed: {
    containerStyle() {
      //这里用了计算属性，用transform来移动整个图片列表
      return {
        transform: `translate3d(${this.distance}px, 0, 0)`
      }
      
    },
  },
 watch: {
   transitionEnd(value) {
       if(value){
         this.$emit('getIndex',this.currentIndex);
       }
   },
   coverimgList:{
      handler: function(){
        console.log(this.coverimgList.length);
        if(this.coverimgList.length==1){
          this.currentIndex = 0;
          this.distance = 0;
        }
      },
      deep: true
    }
 }

};
</script>
<style scoped>
.slider {
  width: 600px;
  overflow: hidden;
}
.banner {
  width: 200px;
  position: relative;
  height: 180px;
  margin: 0 auto;
}
.container {
  display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */
  display: -moz-box; /* Firefox 17- */
  display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
  display: -moz-flex; /* Firefox 18+ */
  display: -ms-flexbox; /* IE 10 */
  display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
 
  
}
.container li {
  width: 200px;
  height: 180px;
  float: left;
  margin: 0 auto;
  position: relative;
}
.container li img {
  width: 180px;
  height: 180px;
  display: block;
  margin: 0 auto;
  padding: 0 10px;
}
.direction li {
  position: absolute;
  top: 70px;
 cursor: pointer;
 width: 50px;
}
.direction li img{
width: 50px;
height: 50px;
}
.left {
  left: -120px;
}
.right {
  right: -120px;
}
.dots {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}
.dots li {
  width: 10px;
  height: 10px;
  display: inline-block;
  margin: 0 2px;
  border-radius: 5px;
  background: #fff;
}
.dots .dotted {
  background: #6b95ff;
}
.shield {
  width: 180px;
  height: 100%;
  position: absolute;
  left: 10px;
  background: rgba(255, 255, 255, 0.6);
  z-index: 999;
}
.shield.actived {
  display: none;
}
</style>






// WEBPACK FOOTER //
// src/components/common/banner.vue